import { RootState } from 'rootReducer';

export const peripheralsSelector = (state: RootState) => state.commonReducer.headerReducer.peripherals;
export const securityGateSelector = (state: RootState) => state.commonReducer.headerReducer.securityGate;
export const securityGateGlobalSelector = (state: RootState) => state.commonReducer.headerReducer;
export const depTitleSelector = (state: RootState) => state.commonReducer.headerReducer.depTitle;
